import React from 'react';
import ServicePageTemplate from './ServicePageTemplate';
import { whatsappCrmAravalliConfig } from './servicePageConfigs';

const WhatsappCrmAravalli = () => (
  <ServicePageTemplate {...whatsappCrmAravalliConfig} />
);

export default WhatsappCrmAravalli;
